<template>
    <div class="entry-listing-wrapper">
         <div class="entry-title">
            <h5 v-if="show_title != false">{{ title }}</h5>
         </div>
         <div class="entry-content">
            <div class="entry-table">
                <table class="table table-striped">
                   <thead>
                      <tr>
                         <th width="50%">Form Name</th>
                         <th width="50%">Entry Actions</th>
                      </tr>
                   </thead>
                   <tbody>
                      <tr v-for="form in forms">
                         <td class="title">
                            <a :href="form.link" v-if="!form.entry_id">
                                {{ form.title }}
                            </a>
                            <span v-else>
                                {{ form.title }}
                            </span>
                         </td>
                         <td class="entry-actions">
                            <span class="text-warning mr-1" v-if="isDraft(form)" v-tooltip="'This entry is in draft mode. Please choose edit to complete.'">
                                 <i class="fa fa-entry-warning fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                            </span>
                            <div class="btn-group" v-if="form.entry_id">
                               <div class="button-group-default" v-if="!read_only">
                                   <a :href="form.edit_link" class="btn btn-primary btn-sm text-white btn-edit-entry mr-05">
                                       <i class="fa fa-pencil mr-05" aria-hidden="true"></i>Edit
                                   </a>
                                   <button class="btn btn-secondary btn-sm btn-delete d-n"  @click="detachEntry(form)">
                                       <i class="fa fa-chain-broken mr-05" aria-hidden="true"></i>Detach
                                   </button>
                               </div>
                               <div class="button-group-readonly" v-else>
                                   <a :href="form.view_link" class="btn-secondary btn-edit-entry btn btn-sm -exempt" target="_blank">
                                       <i class="fa fa-pencil mr-05" aria-hidden="true"></i>View
                                   </a>
                               </div>
                            </div>
                         </td>
                      </tr>
                   </tbody>
                </table>
            </div>
         </div>
      </div>
</template>
<script>
export default {
    props: ['form_requirements', 'title', 'read_only', 'resource', 'show_title'],
    data() {
        return {
            forms: {}
        }
    },
    created() {
        // so we aren't directly editing the prop
        this.forms = _.cloneDeep( this.form_requirements );
    },
    methods: {
        // updateCompleteness() {
        //     this.$emit('updateCompleteness', this.completeness);
        // },
        // updateForms(updatedForms, reloadOnSuccess=false) {
        //     this.forms = updatedForms;
        // },
        detachEntry(form, reloadOnSuccess=false) {
            // let rowData = {
            //     entry_id: form.entry_id
            // };
            //
            // // check the prop to see if there's an additional matching param in the form that need to be met
            // // useful when removing staff because the entry_id and staff position must both match to remove the row
            // if(this.additional_matching_form_data_param) {
            //     rowData.additional_param = {
            //         'sub_field_name': this.additional_matching_form_data_param.section_param,
            //         'value': form[ this.additional_matching_form_data_param.form_param ]
            //     }
            // }
            //
            // $.ajax({
            //     url: localized.resturl + '/' + this.resource + '/' + this.resource_id + '/detach-entry/',
            //     method: 'DELETE',
            //     data: { entry_id: form.entry_id },
            //     beforeSend: function(xhr){
            //         xhr.setRequestHeader( 'X-WP-Nonce', localized.restnonce );
            //     },
            //     dataType: 'json',
            //     success: (result) => {
            //         if(result.success) {
            //             this.forms = result.new_rows;
            //             toastr.success(result.message, 'Success');
            //         } else {
            //             toastr.error(result.message, 'Error');
            //         }
            //     },
            //     error: function(result) {
            //         toastr.error(result, 'Error');
            //     }
            // });
        },
        empty(val) {
            return _.isEmpty(val);
        },
        // for staff positions: the Staff must have a position matching the one listed to attach
        // maybeFilterAttachables(attachables, form) {
        //     if(!this.filter_by_position)
        //         return attachables;
        //
        //     return _.filter(attachables, (attachable) => {
        //         return Object.keys(attachable.positions).includes(form.position);
        //     });
        // },
        isDraft(form) {
            if( !form.entry )
                return false;

            if( form.entry.is_draft == 1 )
                return true;

            return false;
        }
    }
    // computed: {
    //     endpointPrefix() {
    //         return localized.resturl + this.resource;
    //     },
    //     // returns a percentage e.g. 20
    //     completeness() {
    //         let totalFormsLength = this.forms.length;
    //         let completedFormsLength = _.filter(this.forms, (form) => { return form.entry_id != null; }).length;
    //         return Math.floor(totalFormsLength / completedFormsLength * 100);
    //         //
    //         // return {
    //         //     complete: totalFormsLength,
    //         //     total: completedFormsLength
    //         // };
    //     },
    //     isComplete() {
    //         return ( this.completeness == 100 );
    //     },
    //     isAttested() {
    //         return this.$parent.copiedAttested;
    //     }
    // }
    // watch: {
    //     forms() {
    //         this.updateCompleteness();
    //     }
    // }
}
</script>
